import { createSlice } from '@reduxjs/toolkit'

export const dateDataSlice = createSlice({
  name: 'dateData',
  initialState: {
    value: {}
  },
  reducers: {
    setDateData: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setDateData } = dateDataSlice.actions

export default dateDataSlice.reducer